import { Link as RouterLink } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { Box, Card, CardContent, Container, Typography } from '@material-ui/core';
import { PasswordRecoveryJWT } from '../../components/authentication/password-recovery';
import Logo from '../../components/Logo';
import { passCodesApi } from '../../apiCalls/passCodeApi';
import useMounted from '../../hooks/useMounted';

const PasswordRecovery = () => {
  const pageName = `Repor Palavra-Passe | ${process.env.REACT_APP_TITLE}`;
  const mounted = useMounted();

  const handleResetPassword = async (email) => {
    try {
      const response = await passCodesApi.resetPassword(email);
      if (mounted.current) {
        let returnMessage = { error: false, message: '' };
        if (response.error && response.exceptionMessages.hasMessages) {
          returnMessage = { error: true, message: response.exceptionMessages.messages[0] };
        }
        return returnMessage;
      }
      return '';
    } catch (error) {
      return error;
    }
  };

  return (
    <>
      <Helmet>
        <title>{pageName}</title>
      </Helmet>
      <Box
        sx={{
          background: 'linear-gradient(257.68deg, rgba(192, 35, 239, 0.8) 0%, rgba(62, 0, 131, 0.8) 72.88%, rgba(62, 0, 131, 0.8) 93.22%)',
          display: 'flex',
          flexDirection: 'column',
          minHeight: '100vh',
          position: 'relative',
          zIndex: 1
        }}
      >
        <Box sx={{
          backgroundImage: 'url(/static/images/studentsBackground.png)',
          position: 'absolute',
          top: 0,
          bottom: 0,
          right: 0,
          left: 0,
          zIndex: -1,
          backgroundPosition: 'center',
          backgroundSize: 'cover',
          backgroundRepeat: 'no-repeat'
        }}
        />
        <Container
          maxWidth="sm"
          sx={{ py: '80px' }}
        >
          <Box
            component={RouterLink}
            to="/"
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              mb: 8
            }}
          >
            <Logo
              sx={{
                height: 60,
                maxWidth: 300
              }}
              logo="white"
            />
          </Box>
          <Card>
            <CardContent
              sx={{
                display: 'flex',
                flexDirection: 'column',
                p: 4
              }}
            >
              <Typography
                color="textPrimary"
                gutterBottom
                variant="h4"
                sx={{ textAlign: 'center' }}
              >
                Recuperar Palavra-Passe
              </Typography>
              <Box
                sx={{
                  flexGrow: 1,
                  mt: 3
                }}
              >
                <PasswordRecoveryJWT resetPassword={handleResetPassword} />
              </Box>
            </CardContent>
          </Card>
        </Container>
      </Box>
    </>
  );
};

export default PasswordRecovery;
